import { useEffect, useState } from "react";
import { visualizarDocumento } from "../../services/empleado/empleadoDocumentoService";

const FotoMiniatura = ({ id, descripcion }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let objectUrl = null;
        const cargarImagen = async () => {
            try {
                const blob = await visualizarDocumento(id);
                if (blob) {
                    objectUrl = URL.createObjectURL(blob);
                    setImageSrc(objectUrl);
                }
            } catch (error) {
                console.error('Error cargando thumb:', error);
            } finally {
                setLoading(false);
            }
        };

        if (id) cargarImagen();

        // Limpieza de memoria cuando el componente se desmonta
        return () => {
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [id]);

    // Renderizado condicional
    if (loading) return <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem' }}></i>;
    if (!imageSrc) return <i className="pi pi-image text-400" style={{ fontSize: '2rem' }}></i>;
    return (
        <img
            src={imageSrc}
            alt={descripcion}
            className="shadow-2 border-round cursor-pointer"
            style={{ width: '60px', height: '60px', objectFit: 'cover' }}
            onClick={() => window.open(imageSrc, '_blank')}
        />
    );
};

export default FotoMiniatura;
